import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import ru from "./locales/ru.json";
import kk from "./locales/kk.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: "kk", // 👈 ЯЗЫК ПО УМОЛЧАНИЮ
    fallbackLng: "kk",
    supportedLngs: ["kk", "ru", "en"],
    nonExplicitSupportedLngs: true,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: { translation: en },
      ru: { translation: ru },
      kk: { translation: kk },
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });


export default i18n;